// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/** @hidden */
var DayViewGroupRowContentVue2 = {
  name: 'KendoDayViewGroupRowContent',
  props: {
    rangeIndex: Number
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("div", {
      "class": "k-scheduler-cell k-side-cell",
      "data-range-index": this.$props.rangeIndex,
      attrs: this.v3 ? undefined : {
        "data-range-index": this.$props.rangeIndex
      }
    });
  }
};
/** @hidden */
var DayViewGroupRowContent = DayViewGroupRowContentVue2;
export { DayViewGroupRowContent, DayViewGroupRowContentVue2 };